import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"keyboard"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M2 4H22V20H2V4Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M2 4H22V20H2V4Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M6 16H18M5.99609 11.5H6V11.5039H5.99609V11.5ZM9.99609 11.5H10V11.5039H9.99609V11.5ZM13.9961 11.5H14V11.5039H13.9961V11.5ZM17.9961 8.5H18V8.50391H17.9961V8.5ZM17.9961 11.5H18V11.5039H17.9961V11.5ZM13.9961 8.5H14V8.50391H13.9961V8.5ZM9.99609 8.5H10V8.50391H9.99609V8.5ZM5.99609 8.5H6V8.50391H5.99609V8.5Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Keyboard = Vue.extend<IconProps>({
  name: 'KeyboardIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'keyboard',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Keyboard;
